// What a swipe on a feed row does, through the same card operations as the buttons: archive is
// the card's own cleanup action (a reversible mailbox change: one press, Undo), snooze is "Later
// today" (a local change, Undo). Neither ever sends anything.
import type { QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { CardSummary } from "@shared/api";
import { cardQuery } from "@web/lib/feedQueries";
import { runCardAction, snoozeCard } from "@web/feed/cardOps";
import { SNOOZE_PRESETS } from "@web/feed/card/SnoozePicker";
import { swipeArchiveAction } from "./swipe";

export const SWIPE_SNOOZE = SNOOZE_PRESETS[0];

export async function swipeArchive(queryClient: QueryClient, summary: CardSummary): Promise<void> {
  let card;
  try {
    card = await queryClient.fetchQuery(cardQuery(summary.id));
  } catch {
    toast("Couldn't load that card just now. Nothing changed.");
    return;
  }
  const action = swipeArchiveAction(card.actions);
  if (!action) {
    toast("This card has no archive step. Open it to decide.");
    return;
  }
  if (card.updatePending) {
    toast("A newer version of this card waits for the next round. Open it to act on the latest.");
    return;
  }
  await runCardAction(queryClient, card, action);
}

export async function swipeSnooze(queryClient: QueryClient, summary: CardSummary): Promise<void> {
  await snoozeCard(queryClient, summary, SWIPE_SNOOZE.until, SWIPE_SNOOZE.label);
}
